import request from '@/utils/request';
import type {Brand, BrandListResponse, BrandQueryParams, CreateBrandParams, UpdateBrandParams} from '../types/brand';
import type {Category} from '../types/category';
import type {JdCodeOption} from '../types/jd';

export interface UpdateBrandCategories extends Partial<CreateBrandParams> {
  categoryIds: number [];
}

export const brandService = {
  // 获取品牌列表
  getBrandList: (params: BrandQueryParams) => {
    return request.get<BrandListResponse>('/api/admin/product/brand', { params });
  },

  // 创建品牌
  createBrand: (data: CreateBrandParams) => {
    return request.post<Brand>('/api/admin/product/brand', data);
  },

  // 更新品牌
  updateBrand: (data: UpdateBrandParams) => {
    return request.put<Brand>(`/api/admin/product/brand/${data.id}`, data);
  },

  // 删除品牌
  deleteBrand: (id: number) => {
    return request.delete(`/api/admin/product/brand/${id}`);
  },

  // 获取品牌详情
  getBrandDetail: (id: number) => {
    return request.get<Brand>(`/api/admin/product/brand/${id}`);
  },

  // 获取所有启用的品牌
  getEnabledBrands: () => {
    return request.get<Brand[]>('/api/admin/product/brand/enabled');
  },

  // 更新品牌状态
  updateBrandStatus: (id: number, enabled: boolean) => {
    return request.put(`/api/admin/product/brand/${id}/status`, null, { params: { enabled } });
  },

  // 获取品牌下的分类
  getBrandCategories: (brandId: number) => {
    return request.get<Category []>(`/api/admin/product/brand/${brandId}/getBrandCategories`);
  },

  updateBrandCategories: (brandId: number, data: number []) => {
    return request.post(`/api/admin/product/brand/${brandId}/updateBrandCategories`, data);
  },
  // 获取品牌下的分类
  getCategoryBrands: (categoryId: number) => {
    return request.get<Brand []>(`/api/admin/product/brand/${categoryId}/getCategoryBrands`);
  },

  getJdBrandOptions: () => {
    return request.get<JdCodeOption[]>('/api/admin/jd-products/brand-options');
  },
};
